import { Link, useLocation } from "react-router-dom";

const NavItem = ({ dir, dirName, callFunct }) => {
  const location = useLocation();
  const isActive = location.pathname === dir;

  return (
    <Link
      onClick={callFunct}
      to={dir}
      className={`relative w-max ${isActive ? "active" : "" } slide-underline lg:text-sm text-lg tracking-wide font-semibold`}
    >
      <span>{dirName}</span>
      <span
        className={`absolute -bottom-2 left-1/2 transition-all duration-300 h-1 ${
          isActive ? "w-fit" : "w-0"
        } bg-yellow-400`}
      ></span>
      <span
        className={`absolute -bottom-2 right-1/2 transition-all duration-300 h-1 ${
          isActive ? "w-fit" : "w-0"
        } bg-yellow-400`}
      ></span>
    </Link>
  );
};

export default NavItem;
